import { DefaultClipboardProcessor } from 'view/components/datagrid/ClipboardProcessor'
import { CopyPasteFormat } from 'api'

export class CurveGridClipboardProcessor extends DefaultClipboardProcessor {
  constructor({ copyPasteFormat }: { copyPasteFormat?: CopyPasteFormat } = {}) {
    super({ columnIdAccessor: column => column.getColDef().cellRendererParams?.originalColId ?? column.getColId(), copyPasteFormat })
  }

  getHeaderRow(rows: string[]) {
    return rows[2]
  }
}
